import { Injectable } from '@angular/core';
import { AbstractService } from '@services/abstract.service';
import { CustomHttpService } from '@services/generals/custom-http.service';
import { QuestionTypeClass } from '@classes/questionnaires/question-type.class';

@Injectable({
  providedIn: 'root'
})
export class QuestionTypeService extends AbstractService {

  constructor(
    public customHttpService: CustomHttpService
  ) {
    super(customHttpService, new QuestionTypeClass());
      this.version = 'v1';
  }

  public GetIfExist = (id: number) => {
    const self = this;
    const url = self.version + self.base;
    return new Promise(
      resolve => {
        self.customHttpService.httpGET(true, true, url + 'Review/ExistQuestion/' + id).then(
          (response) => {
            resolve(response['data']);
          }
        );
      }
    );
  }

  async deleteQuestion(id: number): Promise<any> {
    const self = this;
    const url = self.version + self.base;
    return await new Promise(
      resolve => {
        self.customHttpService.httpDELETE(
          true,
          true,
          url + 'Review/DeleteQuestion/' + id,
        ).then(
          (response) => {
            //console.log('Que hace este borrado ?: ', response);

            if (response === false) { resolve(response); }
            resolve(true);
          }
        );
      }
    );
  }


}
